import { useMemo } from 'react';
import { usePostHog } from 'posthog-js/react';
import { PostHogInstance } from 'shared/posthogCapture/types';

interface LanguageEditedProperties {
  language_selected: 'en' | 'fr';
}

interface NotificationProperties {
  type: 'all' | 'shift notes' | 'chat';
}

export const createSettingsCaptureEvents = (posthog: PostHogInstance) => ({
  languageEdited: (properties: LanguageEditedProperties) => {
    posthog?.capture('settings / language / edited', properties);
  },
  loggedOutAllDevices: () => {
    posthog?.capture('settings / logout all devices / clicked');
  },
  notificationsDisabled: (properties: NotificationProperties) => {
    posthog?.capture('settings / notifications / disabled', properties);
  },
  notificationsEnabled: (properties: NotificationProperties) => {
    posthog?.capture('settings / notifications / enabled', properties);
  },
  shiftScheduleEditedDays: () => {
    posthog?.capture('settings / shift schedule / edited days');
  },
  shiftScheduleEditedTime: () => {
    posthog?.capture('settings / shift schedule / edited time');
  },
  usernameEdited: () => {
    posthog?.capture('settings / username / edited');
  },
});

export type SettingsCaptureEvents = ReturnType<
  typeof createSettingsCaptureEvents
>;

export const usePosthogCapture = () => {
  const posthog = usePostHog();
  return useMemo(() => createSettingsCaptureEvents(posthog), [posthog]);
};
